<template>
    <div>
        
        <a-row v-if="datacaractive.length !== 0">
            
            <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 16, offset: 4 }" :lg="{ span: 12, offset: 6 }"
                :xl="{ span: 10, offset: 7 }" :xxl="{ span: 8, offset: 8 }">
                
                <div class="mt-20 mb-20 m-ticket">

                    <div class="watermark">
                        <i>MUIC Parking</i>
                    </div>
                    <br>
                    <p class="m">Aditayathorn&nbsp;&nbsp;&nbsp;</p>

                    <div class="movie-details">

                        
                        <div class="movie">
                            <span style="color: #000000;font-size: 32px;font-weight: 700;">{{ datacaractive[0].student_details.title }} {{ datacaractive[0].student_details.english_first_name }}  {{ datacaractive[0].student_details.english_last_name }}</span>
                            <br>
                            <span style="color: #000000;font-size: 16px;font-weight: 700;"> {{ datacaractive[0].student_details.email }} </span>
                            <h4 class="font-web mt-0 mb-0">u{{ datacaractive[0].student_details.student_id }}</h4>
                            <p style="color: #000000;"></p>
                        </div>

                    </div>
                    <div class="info">
                        <strong class="font-web" style="font-size: 16px;">Code : {{ makeid(10,`u${datacaractive[0].student_details.student_id}ParkingTicket`)
                            }}</strong>
                    </div>
                    <div class="ticket-details">
                        <div style="margin-top: -10px; text-align: center;color: #000000;" class="scan">
                            <span style="font-size: 80px; font-weight: 900;">T{{ datacaractive[0].period_details.semester }}</span>
                            <p class="mt-0" style="font-size: 30px; font-weight: 900;">{{ datacaractive[0].period_details.academic_year }}</p>
                        </div>
                        <div class="ticket">
                            <p style="color: #000000;">Sticker schedule</p>

                            <b style="color: #000000; font-weight: 900;">FROM</b>

                            <p style="color: #000000;">{{ moment(datacaractive[0].period_details.parking_start_date).locale('th').add('year',543).format('DD MMM YYYY') }}</p>

                            <b style="color: #000000; font-weight: 900;">To</b>

                            <p style="color: #000000;">{{ moment(datacaractive[0].period_details.parking_end_date).locale('th').add('year',543).format('DD MMM YYYY') }}</p>

                            <h6 style="color: #E73879;">BOOKING ID: {{ datacaractive[0].ref_1 }}</h6>
                        </div>
                    </div>

                    <div class="font-web info-cancel">
                        Mahidol University International College
                    </div>
                    <div class="total-amount">
                        <p>Total Amount</p>
                        <p>{{ datacaractive[0].amount_paid }} Baht</p>
                    </div>
                    <br>
                </div>
            </a-col>
        </a-row>

        <div v-else>
            <a-alert
                message="No Eligible Vehicle Found"
                type="info"
                show-icon
            >
                <template #description>
                    <p class="font-web mt-0 mb-0">
                    You currently do not have any registered vehicles eligible for parking.
                    Please follow the steps below to complete your parking registration and purchase a Parking Rights (Student ID card) .
                    </p>

                    <a-divider />

                    <a-steps class="font-web mt-0 mb-0" direction="vertical" size="small">
                        <a-step  class="font-web mt-0 mb-0" title="Create Your Vehicle Profile" description="Add your vehicle details to the system." />
                        <a-step  class="font-web mt-0 mb-0" title="Purchase Parking Rights (Student ID card) " description="Click the 'Buy Parking Rights (Student ID card) ' button to proceed." />
                        <a-step  class="font-web mt-0 mb-0" title="Complete Payment" description="Pay the parking fee through the system." />
                        <a-step  class="font-web mt-0 mb-0" title="Refresh the System" description="Refresh the page after completing all steps." />
                    </a-steps>
                </template>
            </a-alert>
        </div>

    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        datacaractive: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {};
    },
    mounted() { },
    methods: {
        makeid(length, dataG) {
            let result = '';
            const characters = dataG;
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        }
    },
};
</script>

<style scoped>
/* 
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
  font-family: 'Pathway Extreme', sans-serif;
  user-select:none;
  transition:all .1s;
} */

.body-ticket {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: #ccc;
    overflow: hidden;
}

.msg {
    position: absolute;
    top: 10px;
    left: 10px;
    color: #ffffff;
    text-transform: uppercase;
    z-index: 4;
}

.m-ticket {
    width: 100%;
    background: #fff;
    /* animation: bouncingCard 0.8s ease-out infinite alternate; */
    /* background: rgb(179,174,238); */
    /* background: radial-gradient(circle, rgba(179,174,238,1) 33%, rgba(242,246,255,1) 100%); */
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 25px #bbb;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: move;
}


.m-ticket:before {
    content: "";
    position: absolute;
    left: -33px;
    top: 34%;
    background: #eee;
    box-shadow: inset 0 0 25px #bbb;
    width: 50px;
    height: 50px;
    border-radius: 50%;
}


.m-ticket:after {
    content: "";
    position: absolute;
    right: -33px;
    top: 34%;
    background: #eee;
    box-shadow: inset 0 0 25px #bbb;
    width: 50px;
    height: 50px;
    border-radius: 50%;
}


.m {
    position: absolute;
    right: -5px;
    top: 15%;
    transform: rotate(270.5deg);
    font-size: .80em;
    color: #ffffff;
}


.m-ticket>.movie-details {
    display: flex;
    gap: 20px;
    padding: 20px 20px;
    flex-wrap: wrap;
    justify-content: center;
}


.m-ticket>.movie-details>.poster {
    margin-top: 20px;
    width: 200px;
    height: 100px;
    text-align: center;
    object-fit: contain;
    border-radius: 5px;
    padding: 10px;
    border: 2px solid #000000;
    background-color: #ffffff;
    box-shadow: 0 0 10px #888;
}

.m-ticket>.movie-details>.movie>h4 {
    text-transform: capitalize;
    font-size: 1.6em;
    margin-bottom: 20px;
    width: 200px;
}


.m-ticket>.movie-details>.movie>p {
    font-size: .80em;
    line-height: 19px;
    color: #777;
}


.m-ticket>.info {
    width: 85%;
    border-radius: 20px;
    background: #eee;
    padding: 10px 0px;
    text-align: center;
    font-size: .72em;
}



.m-ticket>.ticket-details {
    display: flex;
    gap: 20px;
    padding: 20px 20px;
    flex-wrap: wrap;
    justify-content: center;
}


.m-ticket>.ticket-details>.scan {
    width: 100px;
    height: 100px;
}

.m-ticket>.ticket-details>.ticket {
    text-align: center;
    width: 200px;
}


.m-ticket>.ticket-details>.ticket>p {
    font-size: .80em;
    line-height: 19px;
    color: #777;
}

.m-ticket>.ticket-details>.ticket>b {
    margin-top: 10px;
    display: inline-block;
    font-size: 1.2em;
    font-weight: 400;
}


.m-ticket>.ticket-details>.ticket>h6 {
    text-transform: uppercase;
    font-weight: 100;
    font-size: .95em;
    margin-top: 10px;
}


.m-ticket>.info-cancel {
    width: 100%;
    background: #eee;
    color: #888;
    padding: 10px 0px;
    text-align: center;
    font-size: .80em;
}


.m-ticket>.total-amount {
    display: flex;
    justify-content: space-between;
    padding: 12px 20px;
    font-weight: 700;
    font-size: .90em;
    width: 100%;
}

.watermark {
    color: rgb(156, 60, 60);
    opacity: 0.2;
    /* background-color:rgba(255, 0, 0, 0.5); */
    height: 30px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 5px;
    right: 10px;
}

/* Ticket Bouncing Animation */
@keyframes bouncingCard {
    from {
        transform: translateY(0);
    }

    to {
        transform: translateY(-18px);
    }
}

@keyframes bouncingShadow {
    from {
        transform: translateY(0px);
    }

    to {
        transform: translateY(4px);
    }
}

/* Mobile Responsive Styles */
@media screen and (max-width: 576px) {
    .m-ticket > .movie-details {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .m-ticket > .movie-details > .poster {
        margin-top: 0;
        margin-bottom: 10px;
    }

    .m-ticket > .movie-details > .movie > h4 {
        width: auto;
        margin-bottom: 10px;
    }

    .m-ticket > .ticket-details {
        flex-direction: column-reverse; /* Put QR code below details on mobile if desired, or column for standard order */
        align-items: center;
        text-align: center;
    }

    .m-ticket > .ticket-details > .scan {
        margin-top: 20px;
    }

    .m-ticket > .ticket-details > .ticket {
        width: 100%;
    }
    
    .m-ticket:before,
    .m-ticket:after {
        display: none; /* Hide the cutout circles on mobile to save space/cleaner look */
    }
}
</style>